import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Products from '../views/Products.vue'
import ProductArtworks from '../views/ProductArtworks.vue'
import ArtworkFields from '../views/ArtworkFields.vue'
import ArtworkColors from '../views/ArtworkColors.vue'
import ProductCategory from '../views/ProductCategory.vue'

import DyoProductCategory from '../views/DyoProductCategory.vue'
import DyoProducts from '../views/DyoProducts.vue'
import DyoProductEdit from '../views/DyoProductEdit.vue'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/dashboard',
    name: 'Home',
    component: Home
  },
  {
    path: '/products',
    name: 'Manage Products',
    component: Products
  },
  {
    path: '/dyo/category',
    name: 'Dyo Product Category',
    component: DyoProductCategory
  },
  {
    path: '/dyo/products',
    name: 'Dyo Products',
    component: DyoProducts
  },
  {
    path: '/data-sources',
    name: 'Data Sources',
    component: () => import('../views/DataSources.vue')
  },
  {
    path: '/data-sources/:source_id',
    name: 'Data Source',
    component: () => import('../views/DataSourceFields.vue')
  },
  {
    path: '/product/category',
    name: 'Product Category',
    component: ProductCategory
  },
  {
    path: '/dyo/product/:product_id/edit',
    name: 'Product Edit',
    component: DyoProductEdit
  },
  {
    path: '/dyo/product/:product_id/artworks',
    name: 'Product Artworks',
    component: ProductArtworks
  },
  {
    path: '/dyo/colors',
    name: 'Artwork Colors',
    component: ArtworkColors
  },
  {
    path: '/dyo/artwork/:artwork_id',
    name: 'Artwork Fields',
    component: ArtworkFields
  },
  {
    path: '/dyo/designs',
    name: 'Dyo Designs',
    component: () => import('../views/DyoDesigns.vue')
  },
  {
    path: '/user-roles',
    name: 'User Roles',
    component: () => import('../views/UserRoles.vue')
  },
  {
    path: '/uploads',
    name: 'Uploads',
    component: () => import('../views/Uploads.vue')
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/Users.vue')
  },
  {
    path: '/action',
    name: 'Action',
    component: () => import('../views/Action.vue')
  },
  {
    path: '/orders',
    name: 'Manage Orders',
    component: () => import('../views/Orders.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('../views/Logout.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
